import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { AssignmentOutlined } from '@mui/icons-material';
import { BRAND_COLOR, BRAND_COLOR_DARK } from './FormSection';

const QuestionnairesSection = ({ selectedQuestionnaires, openQuestionnaireModal }) => {
  const hasSelection = selectedQuestionnaires.length > 0;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 2,
        border: '2px dashed',
        borderColor: hasSelection ? 'divider' : `${BRAND_COLOR}66`,
        bgcolor: hasSelection ? '#fff' : `${BRAND_COLOR}08`,
        textAlign: hasSelection ? 'left' : 'center',
      }}
    >
      {hasSelection ? (
        <Stack spacing={2}>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {selectedQuestionnaires.map((questionnaire) => (
              <Chip
                key={questionnaire.id}
                icon={<AssignmentOutlined />}
                label={questionnaire.title || `Cuestionario #${questionnaire.id}`}
                sx={{
                  bgcolor: `${BRAND_COLOR}1A`,
                  color: BRAND_COLOR_DARK,
                  fontWeight: 500,
                  '& .MuiChip-icon': { color: BRAND_COLOR_DARK },
                }}
              />
            ))}
          </Stack>
          <Box>
            <Button
              variant="outlined"
              startIcon={<AssignmentOutlined />}
              onClick={openQuestionnaireModal}
              sx={{ color: BRAND_COLOR_DARK, borderColor: BRAND_COLOR, fontWeight: 600 }}
            >
              Modificar selección
            </Button>
          </Box>
        </Stack>
      ) : (
        <Stack spacing={1.5} alignItems="center">
          <AssignmentOutlined sx={{ fontSize: 40, color: BRAND_COLOR }} />
          <Typography color="text.secondary">Aún no hay cuestionarios seleccionados.</Typography>
          <Button
            variant="contained"
            startIcon={<AssignmentOutlined />}
            onClick={openQuestionnaireModal}
            sx={{ bgcolor: BRAND_COLOR, '&:hover': { bgcolor: BRAND_COLOR_DARK }, fontWeight: 600 }}
          >
            Seleccionar cuestionarios
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default QuestionnairesSection;
